import React from 'react';
import cn from "classnames";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";

export type ImageBlockType = Omit<FormBlockType, "data"> & {
    data: {
        image: string;
        width: number;
        align: string;
        border_radius: number;
    }
}

export default function ImageBlock(block: ImageBlockType) {
    const { image, width, align, border_radius } = block.data;
    const borderRadiusCn = cn(
        border_radius == 0 ? "rounded-none" : "",
        border_radius == 1 ? "rounded" : "",
        border_radius == 2 ? "rounded-md" : "",
        border_radius == 3 ? "rounded-lg" : "",
        border_radius == 4 ? "rounded-xl" : "",
        border_radius == 5 ? "rounded-2xl" : "",
        border_radius == 6 ? "rounded-3xl" : "",
        border_radius == 7 ? "rounded-full" : "",
    );

    const alignmentCn = cn(
        { 'mr-auto': align == 'left' },
        { 'ml-auto': align == 'right' },
        { 'mx-auto': align == 'center' },
    );

    const imageCn = cn(
        borderRadiusCn,
        alignmentCn
    );

    return (
        <img
            alt={"image"}
            src={image}
            className={imageCn}
            style={{ width: width + "%" }}
        />
    );
}